import React from 'react';
import { Outlet, useLocation, Link } from 'react-router-dom';
import './pages/HomePage.css';

export const Layout: React.FC = () => {
  const location = useLocation();
  const isHome = location.pathname === '/';

  // HomePage manages its own full-screen layout
  if (isHome) {
    return <Outlet />;
  }

  return (
    <div className="tw-min-h-screen tw-flex tw-flex-col tw-bg-gray-50" style={{ paddingBottom: '44px' }}>
      {/* Header for sub-pages */}
      <header className="tw-bg-white tw-shadow-sm tw-py-3 tw-px-4 sm:tw-px-6">
        <div className="tw-max-w-5xl tw-mx-auto tw-flex tw-items-center tw-justify-between tw-gap-3">
          <a href="/" className="tw-no-underline tw-flex tw-items-center tw-gap-3">
            <img
              src="/assets/logos/toyo-tires-logo-Bleu.png"
              alt="TOYO TIRES"
              className="tw-h-7 sm:tw-h-8 tw-object-contain"
            />
          </a>
          <div className="tw-text-right tw-shrink-0">
            <a href="tel:0978454532" className="tw-text-gray-500 tw-no-underline hover:tw-text-gray-700 tw-transition-colors tw-flex tw-items-center tw-gap-1">
              <span className="tw-text-sm">📞</span>
              <span className="tw-text-base sm:tw-text-xl tw-font-bold">09 78 45 45 32</span>
            </a>
            <p className="tw-hidden sm:tw-block tw-text-xs tw-text-gray-400 tw-mb-0">De 9h à 12h30 et de 14h à 17h30 · Appel gratuit</p>
          </div>
        </div>
      </header>

      {/* Main content */}
      <main className="tw-flex-1">
        <div className="tw-max-w-5xl tw-mx-auto tw-px-4 sm:tw-px-6 tw-py-8">
          <Outlet />
        </div>
      </main>

      {/* Footer */}
      <footer className="sor-home__footer" style={{ background: '#0062B0', backdropFilter: 'none' }}>
        <p className="sor-home__footer-left">
          © 2026 TOYO TIRES — Garantie Satisfait ou Remboursé
        </p>
        <div className="sor-home__footer-links">
          <Link to="/mentions-legales" className="sor-home__footer-link">
            Mentions légales
          </Link>
          <span className="sor-home__footer-sep">·</span>
          <Link to="/politique-de-confidentialite" className="sor-home__footer-link">
            Politique de confidentialité
          </Link>
          <span className="sor-home__footer-sep">·</span>
          <Link to="/conditions-generales" className="sor-home__footer-link">
            Conditions Générales de la garantie
          </Link>
        </div>
      </footer>
    </div>
  );
};
